import { render, staticRenderFns } from "./Diversity.vue?vue&type=template&id=66a802b6"
import script from "./Diversity.vue?vue&type=script&lang=js"
export * from "./Diversity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LinkResolver: require('/home/runner/work/marketing/marketing/components/LinkResolver.vue').default})
